package com.routexk.quiz.utils

object Validation {

    private val EMAIL_REGEX = "^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}\$".toRegex()

    fun isValidEmail(email: String): Boolean {
        return email.isNotBlank() && EMAIL_REGEX.matches(email)
    }

    fun isValidPassword(password: String, minLength: Int = 8): Boolean {
        return password.length >= minLength &&
                password.any { it.isUpperCase() } &&
                password.any { it.isLowerCase() } &&
                password.any { it.isDigit() }
    }

    fun isNotEmpty(value: String?): Boolean {
        return !value.isNullOrBlank()
    }

    fun isValidUrl(url: String): Boolean {
        return try {
            js("new URL(url)") != null
        } catch (e: Exception) {
            false
        }
    }
}
